import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../hooks";

const Logout = () => {
  const navigate = useNavigate();
  const { setAuthToken } = useStore();

  useEffect(() => {
    setAuthToken(null);
    navigate("/login");
  }, []);

  return null;
};

export default Logout;
